import { render } from "./bran_free_list.vue?vue&type=template&id=1bb6f06c"
import script from "./bran_free_list.vue?vue&type=script&lang=js"
export * from "./bran_free_list.vue?vue&type=script&lang=js"

import exportComponent from "D:\\vue\\ydd-zht-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__